import { weightOptions } from './weightOptions';

export function getWeightLabel(fontWeight: string) {
  const weight = weightOptions.find((w) => w.value === fontWeight);
  return weight?.label || 'Regular';
}
